import React, {useContext, useEffect, useState} from 'react';
import { useHistory, Link } from 'react-router-dom';
import { apiRoutes } from '../../../AppSettings';
import { AuthContext } from '../../../contexts/AuthContext';
import Util from '../../../Util';
import axios from 'axios';

const SideNav = props => {
    const doctor = props.user;
    const history = useHistory();
    const { userState, resetUserState } = useContext(AuthContext); 
    const [messageCount, setMessageCount] = useState(0); 

    const logouthandler = () => {
        resetUserState();
        history.push('/');
    };

    useEffect(() => {
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'bearer ' + userState.token
            }
        };

        axios.get(apiRoutes.GetMessageCount + doctor.doctorId + '/' + userState.userType, options)
            .then((response) => {
            if (response.status === 200) {
                const data = response.data;
                console.log('messageCount: ') 
                console.log(data)
                setMessageCount(data.result);
            }
        }, (error) => {
            console.log(error);
        });
    }, []);

    return (
        <div className="profile-sidebar">
            <div className="widget-profile pro-widget-content">
                <div className="profile-info-widget">
                    <a href="#" className="booking-doc-img">
                        <img src={Util.loadImage(doctor.profileImage)} alt="User" />
                    </a>
                    <div className="profile-det-info">
                        <h3>Dr. {doctor.firstName} {doctor.lastName}</h3>

                        <div className="patient-details">
                            <h5 className="mb-0">BDS, MDS - Oral & Maxillofacial Surgery</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div className="dashboard-widget">
                <nav className="dashboard-menu">
                    <ul>
                        <li className={props.applyCssFor === 'dashboard' ? 'active' : ''} >
                            <a href="#/doctordashboard">
                                <i className="fas fa-columns"></i>
                                <span>Dashboard</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'appointmenta' ? 'active' : ''} >
                            <a href="#/appointment">
                                <i className="fas fa-calendar-check"></i>
                                <span>Appointments</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'mypatients' ? 'active' : ''} >
                            <a href="#/mypatients">
                                <i className="fas fa-user-injured"></i>
                                <span>My Patients</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'scheduletiming' ? 'active' : ''} >
                            <a href="#/scheduletiming">
                                <i className="fas fa-hourglass-start"></i>
                                <span>Schedule Timings</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'invoices' ? 'active' : ''}>
                            <a href="#/invoice"> 
                                <i className="fas fa-file-invoice"></i>
                                <span>Invoices</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'doctorreview' ? 'active' : ''}>
                            <a href="#/doctorreview">
                                <i className="fas fa-star"></i>
                                <span>Reviews</span>
                            </a>
                        </li>
                        <li>
                            <Link to={
                                {
                                    pathname: `/chat`
                                }
                            }><i className="far fa-comments"></i>
                             <span>Message</span>
                                {
                                    messageCount != undefined && messageCount != 0
                                    && <small className="unread-msg">{messageCount}</small>
                                }
                            </Link>


                        </li>
                        <li className={props.applyCssFor === 'doctorprofilesetting' ? 'active' : ''} >
                            <a href="#/doctorprofilesetting">
                                <i className="fas fa-user-cog"></i>
                                <span>Profile Settings</span>
                            </a>
                        </li>
                        <li className={props.applyCssFor === 'changepassword' ? 'active' : ''} >
                            <a href="#/docchangepassword">
                                <i className="fas fa-lock"></i>
                                <span>Change Password</span>
                            </a>
                        </li>
                        <li>
                            <Link onClick={logouthandler}>
                                <i className="fas fa-sign-out-alt"></i>
                                <span>Logout</span>
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
};

export default SideNav;